export default {
  content: {
    position: 'fixed',
    height: '100vh',
    width: '100%',
    top: 0,
    left: 0,
    zIndex: 100,
    background: '#fff',
    lineHeight: '22px'
  },
  beforeAfter: {
    height: '50vh',
    padding: 20,
    lineHeight: '22px',
    whiteSpace: 'pre-wrap'

  },
  change: {
    height: 'calc(50vh - 115px)',
    padding: '20px 20px 100px 20px',
    marginTop: -15
  },
  index:{
    height: '100vh',
    overflow: 'auto'    
  },
  toolbar: {
    position: 'fixed',
    bottom: 20,
    right: 20
  },
  col: {
    position: 'relative'
  },
  colTitle: {
    position: 'absolute',
    top: 2,
    right: 30,
    zIndex: 100,
    background: '#fff',
    padding: 3,
    fontWeight: 'bold'
  }
}


// WEBPACK FOOTER //
// ./src/sba/sba.css.js